export abstract class ApplicationStage {
  public type = 'ApplicationStage';
  constructor() {
    if (this.constructor.name === 'ApplicationStage') {
      throw new Error('ApplicationStage is an abstract class. You can’t have an instance of it');
    }
  }
}
export class Onboarding extends ApplicationStage {
  public readonly type = 'Onboarding';
}
export class DocumentsCheck extends ApplicationStage {
  public readonly type = 'DocumentsCheck';
}

export class TenantDisclaimer extends ApplicationStage {
  public readonly type = 'TenantDisclaimer';
}
export class ApplicationInProgress extends ApplicationStage {
  public readonly type = 'ApplicationInProgress';
}
export class WithCreditStudy extends ApplicationStage {
  public readonly type = 'WithCreditStudy';
}

export class AddCotenant extends ApplicationStage {
  public readonly type = 'AddCotenant';
}

export class ApplicantBasicInformation extends ApplicationStage {
  public readonly type = 'ApplicantBasicInformation';
}

export class ApplicantCharacterization extends ApplicationStage {
  public readonly type = 'ApplicantCharacterization';
}

export class DocumentsUpload extends ApplicationStage {
  public readonly type = 'DocumentsUpload';
}

export class SuccessfulApplication extends ApplicationStage {
  public readonly type = 'SuccessfulApplication';
}
export class LeaveApplication extends ApplicationStage {
  public readonly type = 'LeaveApplication';
}
export class Loading extends ApplicationStage {
  public readonly type = 'Loading';
}

export class ErrorApplication extends ApplicationStage {
  public readonly type = 'ErrorApplication';
  public error: string;

  constructor(error: string) {
    super();
    this.error = error;
  }
}

export enum ApplicationStateSteps {
  onboarding = 'onboarding',
  documentsCheck = 'documentsCheck',
  tenantDisclaimer = 'tenantDisclaimer',
  basicInformation = 'basicInformation',
  applicantCharacterization = 'applicantCharacterization',
  documentsUpload = 'documentsUpload',
  successfulApplication = 'successfulApplication',
  errorApplication = 'errorApplication',
  applicationInProgress = 'applicationInProgress',
  withCreditStudy = 'withCreditStudy',
  addCotenant = 'addCotenant',
  leaveApplication = 'leaveApplication',
  loading = 'loading',
}

export const getApplicationStage = (currentStage: ApplicationStateSteps, error: string): ApplicationStage => {
  switch (currentStage) {
    case 'onboarding':
      return new Onboarding();
    case 'documentsCheck':
      return new DocumentsCheck();
    case 'tenantDisclaimer':
      return new TenantDisclaimer();
    case 'applicationInProgress':
      return new ApplicationInProgress();
    case 'withCreditStudy':
      return new WithCreditStudy();
    case 'addCotenant':
      return new AddCotenant();
    case 'basicInformation':
      return new ApplicantBasicInformation();
    case 'applicantCharacterization':
      return new ApplicantCharacterization();
    case 'documentsUpload':
      return new DocumentsUpload();
    case 'successfulApplication':
      return new SuccessfulApplication();
    case 'leaveApplication':
      return new LeaveApplication();
    case 'errorApplication':
      return new ErrorApplication(error);
    case 'loading':
      return new Loading();
    default:
      return new ErrorApplication('Error: Unknown application state');
  }
};
